import { Dropdown } from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { noSelectionKey } from '../../../../utilities/filterAndSortingsUtil';
import { optionsMapperWithNoSelection } from '../../../../utilities/mapperFunctions';

export const HearingTypeDropdownAndTooltip = ({
  hearingTypes,
  onChangeDropdown,
  selectedHearingTypeKey,
  selectionCount,
}) => {
  const { t: translator } = useTranslation();

  return (
    <div className="administration-page-parent-row-stack">
      <div className="administration-page-dropdown">
        <div className="admin-page-container-filters-specific">
          <Dropdown
            label={translator('hearingProperties.hearingType')}
            styles={dropdownStyles}
            options={optionsMapperWithNoSelection(translator)(hearingTypes)}
            onChange={onChangeDropdown}
            selectedKey={selectedHearingTypeKey}
          />
        </div>
        <ReactMarkdown
          source={translator('pages.adminKleMappings.subHeader')}
          linkTarget={'_blank'}
        />
      </div>
      {selectedHearingTypeKey !== noSelectionKey ? (
        <p
          style={{ fontWeight: 500, fontSize: 'medium', paddingBottom: '5px' }}
        >{` ${translator(
          'pages.adminKleMappings.kleSelectedCounter',
        )} ${selectionCount}`}</p>
      ) : null}
    </div>
  );
};

const dropdownStyles = {
  root: {
    width: '30%',
    minWidth: '300px',
    maxWidth: 425,
    height: 32,
  },
  dropdownOptionText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};
